module.exports = __webpack_public_path__ + "img/112.26156d69.jpg";